module.exports = require("zenscroll");


//////////////////
// WEBPACK FOOTER
// external "zenscroll"
// module id = 583
// module chunks = 0